import { create } from 'zustand';

interface TrialState {
  daysLeft: number | null;
  expiresAt: string | null;
  isSuspended: boolean;
  update: (daysLeft: number | null, expiresAt: string | null, suspended: boolean) => void;
}

export const useTrialStore = create<TrialState>((set) => ({
  daysLeft: null,
  expiresAt: null,
  isSuspended: false,
  update: (daysLeft, expiresAt, isSuspended) => set({ daysLeft, expiresAt, isSuspended }),
}));
